/**
 * DAH Association Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NameResponse } from './nameResponse';
import { ProjectContactResponse } from './projectContactResponse';
import { ProjectProgressModel } from './projectProgressModel';


export interface ProjectResponse { 
    amount?: number;
    associations?: Array<NameResponse>;
    category?: ProjectResponse.CategoryEnum;
    company?: NameResponse;
    contacts?: Array<ProjectContactResponse>;
    contractType?: ProjectResponse.ContractTypeEnum;
    counterParty?: NameResponse;
    created?: string;
    delayDate?: string;
    failReason?: ProjectResponse.FailReasonEnum;
    failed?: string;
    id?: string;
    manager?: NameResponse;
    name?: string;
    nextTaskDate?: string;
    organization?: NameResponse;
    progress?: Array<ProjectProgressModel>;
    responsible?: NameResponse;
    source?: ProjectResponse.SourceEnum;
    state?: ProjectResponse.StateEnum;
    status?: ProjectResponse.StatusEnum;
}
export namespace ProjectResponse {
    export const CategoryEnum = {
        Creating: 'CREATING',
        HousingCoop: 'HOUSING_COOP',
        HousingOffice: 'HOUSING_OFFICE',
        FopManager: 'FOP_MANAGER',
        CottageTown: 'COTTAGE_TOWN',
        GarageCoop: 'GARAGE_COOP',
        GardenSociety: 'GARDEN_SOCIETY'
    } as const;
    export type CategoryEnum = typeof CategoryEnum[keyof typeof CategoryEnum];
    export const ContractTypeEnum = {
        Social: 'SOCIAL',
        Finances: 'FINANCES',
        Accounting: 'ACCOUNTING'
    } as const;
    export type ContractTypeEnum = typeof ContractTypeEnum[keyof typeof ContractTypeEnum];
    export const FailReasonEnum = {
        Concurrent: 'CONCURRENT',
        Expensive: 'EXPENSIVE',
        Conditions: 'CONDITIONS',
        OtherSoft: 'OTHER_SOFT',
        NoAnswer: 'NO_ANSWER',
        NonGoal: 'NON_GOAL'
    } as const;
    export type FailReasonEnum = typeof FailReasonEnum[keyof typeof FailReasonEnum];
    export const SourceEnum = {
        Ads: 'ADS',
        Cold: 'COLD',
        Regular: 'REGULAR',
        Partner: 'PARTNER',
        Webinar: 'WEBINAR',
        Recommendation: 'RECOMMENDATION'
    } as const;
    export type SourceEnum = typeof SourceEnum[keyof typeof SourceEnum];
    export const StateEnum = {
        Low: 'LOW',
        Normal: 'NORMAL',
        High: 'HIGH'
    } as const;
    export type StateEnum = typeof StateEnum[keyof typeof StateEnum];
    export const StatusEnum = {
        New: 'NEW',
        Registration: 'REGISTRATION',
        Contract: 'CONTRACT',
        Done: 'DONE',
        Fail: 'FAIL',
        Active: 'ACTIVE'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


